import React, { useState } from 'react';
import {
    ActionHeader,
    Gutter,
    GutterCap,
    Header
} from '../../../generic/AsTable/Standard';
import CampaignNotesDataRow from './CampaignNotesDataRow';

const CampaignNotesDataRows = ({
    data = [],
    onChange,
    rowHeight,
    visibleRows,
    readOnly,
    onEdit,
    onDelete,
    onLinkClick
}) => {
    const [scrollPx, setScrollPx] = useState(0);
    const [highlightedRow, setHighlightedRow] = useState(-1);

    const padWithEmptyRows = () => {
        const retVal = [];
        for (let i = data.length; i < visibleRows; i++) {
            retVal.push(
                <CampaignNotesDataRow
                    key={i}
                    index={i}
                    scrollPx={scrollPx}
                    rowHeight={rowHeight}
                    visibleRows={visibleRows}
                    hideEditable={true}
                />
            );
        }

        return retVal;
    };

    return (
        <>
            <ActionHeader area={'actionH'} scrollPx={scrollPx} />

            <Header
                area={'nameH'}
                style={{ borderWidth: '1px 1px 1px 0' }}
                scrollPx={scrollPx}
            >
                {window.translate('Name')}
            </Header>

            <Header area={'descriptionH'} scrollPx={scrollPx}>
                {window.translate('Description')}
            </Header>

            <Header area={'typeH'} scrollPx={scrollPx}>
                {window.translate('Type')}
            </Header>

            <Header area={'dateCreatedH'} scrollPx={scrollPx}>
                {window.translate('Date Created')}
            </Header>

            <Header
                area={'ownerH'}
                style={{ borderWidth: '1px 0 1px 0' }}
                scrollPx={scrollPx}
            >
                {window.translate('Owner')}
            </Header>

            <GutterCap />

            {data.map((entity, i) => (
                <CampaignNotesDataRow
                    key={i}
                    index={i}
                    entity={entity}
                    scrollPx={scrollPx}
                    onChange={onChange}
                    onHover={setHighlightedRow}
                    isHighlighted={highlightedRow === i}
                    rowHeight={rowHeight}
                    visibleRows={visibleRows}
                    readOnly={readOnly}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onLinkClick={onLinkClick}
                />
            ))}

            <Gutter
                scrollPx={scrollPx}
                onScroll={setScrollPx}
                scrollableLength={data.length * rowHeight}
                maxVisibleLength={visibleRows * rowHeight}
            />

            {padWithEmptyRows()}
        </>
    );
};

export default CampaignNotesDataRows;
